import { TEventDetail } from "@letshang/constants"
import { get, isEmpty } from "lodash-es"

import { getEventDetails } from "@api/firebaseWrappedApis"

export enum searchGroupsBy {
  Id = "id",
  Name = "name",
}

export enum SearchType {
  Events = "events",
  Groups = "groups",
}

export interface SearchResultResponseType {
  id: string
  title: string
  icon: string
  subTitle: string
  type: SearchType
  image?: string
  startTime?: string | number
  isAdmin?: boolean
  textColor?: string
  ticketMinPrice?: number
}

const filter = (text: string, result: SearchResultResponseType) => {
  const lowerText = text.toLocaleLowerCase()
  const titleMatches = result?.title?.toLocaleLowerCase().includes(lowerText)

  const subTitleMatches =
    typeof result?.subTitle === "string"
      ? result?.subTitle?.toLocaleLowerCase().includes(lowerText)
      : false

  return titleMatches || subTitleMatches
}

export const filterById = (id: string, result: SearchResultResponseType) => {
  return result.id.toLocaleLowerCase().includes(id)
}

export const getResultsWithSearchTerm = (
  text: string,
  results: SearchResultResponseType[],
  searchBy: searchGroupsBy = searchGroupsBy.Name,
) => {
  if (searchBy === searchGroupsBy.Id) {
    return results.filter((result) => filterById(text, result))
  }
  if (text) {
    return results.filter((result) => filter(text, result))
  } else {
    return []
  }
}

/**
 * @params {stirng} take entire url
 * @process Find groups id
 * @return { {type , id} | } return the groups id
 */

export const findSearchTypeAndId = (url: string) => {
  // Regular expression to match the type and ID
  const regex = /\/(groups|events)\/([^/]+)/

  // Extracting type and ID
  const match = url.match(regex)

  if (match) {
    const type = match[1]
    const id = match[2]
    return {
      type: type,
      id: id,
    }
  } else {
    return undefined
  }
}

export const fetchSearchResult = (
  id: string,
  uid: string,
): Promise<SearchResultResponseType> => {
  return new Promise((resolve, reject) => {
    getEventDetails({ eventId: id, uid })
      .then((result) => {
        const eventData: TEventDetail = get(result, "data") || []
        if (!isEmpty(eventData)) {
          resolve({
            id,
            icon: "🗓️",
            title: eventData?.eventDocData?.eventName,
            subTitle: eventData?.eventDocData?.location?.eventLocation,
            type: SearchType.Events,
            image: get(eventData, "eventDocData.flyerImage", ""),
            isAdmin: uid === eventData?.eventDocData?.initiatorUid,
            startTime: eventData?.eventDocData?.timing?.eventStartTime,
            ticketMinPrice: get(eventData, "minTicketPrice"),
          })
        } else {
          reject(result)
        }
      })
      .catch((error) => reject(error))
  })
}
